import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content for safe rendering via dangerouslySetInnerHTML.
 * Allows standard HTML tags from TinyMCE output including iframes for embedded content.
 */
export function sanitizeHtml(html) {
    if (!html) return '';
    return DOMPurify.sanitize(html, {
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['target', 'allowfullscreen', 'frameborder'],
        ALLOW_ARIA_ATTR: true
    });
}
